import { B2C_PAYMENTS_PATH, B2C_PAYPAL_CANCEL_REDIRECT_PATH, B2C_PAYPAL_INIT_PATH, B2C_PAYPAL_RETURN_PATH, B2C_PAYPAL_SAVE_PATH, } from '../../constants/links';
import { apiB2C } from '../axios-client';
export const b2cPaymentsApi = {
    getCreditAndPaypalCards: () => apiB2C.get(B2C_PAYMENTS_PATH, {
        params: {
            pageSize: 0,
            pageNumber: 0,
        },
    }),
    paypalInit: () => apiB2C.put(B2C_PAYPAL_INIT_PATH, {
        paypal: {
            cancelUrl: B2C_PAYPAL_CANCEL_REDIRECT_PATH,
            returnUrl: B2C_PAYPAL_RETURN_PATH,
            requestType: 'InitPaypal',
        },
    }),
    paypalSave: (tokenId, payerId) => apiB2C.put(B2C_PAYPAL_SAVE_PATH, {
        paypal: {
            tokenId,
            payerId,
            requestType: 'VerifyAndSave',
        },
    }),
    deletePayments: (paymentId) => apiB2C.post(`${B2C_PAYMENTS_PATH}/delete`, {
        PaymentCardRequest: { paymentId },
    }),
    updateCreditCard: (creditCard) => {
        const payload = {
            paymentCards: {
                paymentCard: [creditCard],
            },
        };
        return apiB2C.put(B2C_PAYMENTS_PATH, payload);
    },
};
